
window.addEventListener('cart.init', (e) => {
    var _ss = window._ss || [];
    let { cart } = e.detail;

    _ss.push(['_setTransaction', {
        'transactionID': `${ cart.id }`,
    }]);
});

window.addEventListener('cart.checkout', (e) => {
    var _ss = window._ss || [];
    let { cart, order } = e.detail;

    _ss.push(['_setTransaction', {
        'transactionID': `${ cart.id }`,
        'storeName': `${ window.env['APP_NAME'] }`,
        'total': `${ parseFloat(_.get(order, 'amount_billed', 0)).toFixed(2) }`,
        'tax': `${ parseFloat(_.get(order, 'gst', 0)).toFixed(2) }`,
        'shipping': `${ parseFloat(_.get(order, 'freight_total', 0)).toFixed(2) }`,
        'city': `${ _.get(order, 's_city', 0) }`,
        'state': `${ _.get(order, 's_city', 0) }`,
        'zipcode': `${ _.get(order, 's_postcode', 0) }`,
        'country': `${ _.get(order, 's_country', 0) }`,
        // the following params can be used for creating/updating
        // a contact in the context of the supplied transaction data.
        // if this data is omitted, the underlying contact/tracking data
        // associated with the visitors browser session is used automatically.
        'firstName' : `${ _.get(order, 'firstname', 0) }`, // optional parameter
        'lastName' : `${ _.get(order, 'lastname', 0) }`, // optional parameter
        'emailAddress' : `${ _.get(order, 'email', 0) }`, // optional parameter
        // 'cartUrl': 'https://www.shopify.com/your/cart' // optional parameter
    }]);

    _ss.push(['_completeTransaction', {
        'transactionID': `${ cart.id }`
    }]);

});

window.addEventListener('cart.item.create', (e) => {
    var _ss = window._ss || [];
    let { cart, item } = e.detail;

    let categoryname = `${ _.chain(item)
        .get('product.categories', [])
        .first()
        .get('fullname')
        .value() }`;
    let productid = `${ _.get(item, 'price.code', '') }`;
    let productname = `${ _.get(item, 'price.description', '') }`;
    let productpath = `${ _.get(item, 'product.path', '') }`;
    let productimage = `${ _.get(item, 'product.image.link', '/asset/null.jpg') }`;
    let productsales = `${ _.chain(item)
        .get('item_price')
        .value()
    }`;
    let quantity = `${ _.get(item, 'quantity') }`;

    _ss.push(['_addTransactionItem', {
        'transactionID': `${ cart.id }`,
        'itemCode': productid,
        'productName': productname,
        'category': categoryname,
        'price': productsales,
        'quantity': quantity,
        'productURL': window.location.origin + productpath, // optional parameter
        'imagePath' : window.location.origin + productimage, // optional parameter
    }]);
});

window.addEventListener('cart.item.update', (e) => {
    var _ss = window._ss || [];
    let { cart, item } = e.detail;

    let categoryname = `${ _.chain(item)
        .get('product.categories', [])
        .first()
        .get('fullname')
        .value() }`;
    let productid = `${ _.get(item, 'price.code') }`;
    let productname = `${ _.get(item, 'price.description') }`;
    let productsales = `${ _.chain(item)
        .get('item_price')
        .value()
    }`;
    let quantity = `${ _.get(item, 'quantity') }`;

    _ss.push(['_addTransactionItem', {
        'transactionID': `${ cart.id }`,
        'itemCode': productid,
        'productName': productname,
        'category': categoryname,
        'price': productsales,
        'quantity': quantity,
        // 'productURL': 'https://yourcompany.com/olivemedium/tshirt', // optional parameter
        // 'imagePath' : 'https://yourcompany.com/olivemedium/tshirt.png' // optional parameter
    }]);
});

window.addEventListener('cart.item.delete', (e) => {
    var _ss = window._ss || [];
    let { cart, item } = e.detail;

    let productid = `${ _.get(item, 'price.code') }`;

    _ss.push(['_addTransactionItem', {
        'transactionID': `${ cart.id }`,
        'itemCode': productid,
        'quantity': -1,
        // 'productURL': 'https://yourcompany.com/olivemedium/tshirt', // optional parameter
        // 'imagePath' : 'https://yourcompany.com/olivemedium/tshirt.png' // optional parameter
    }]);
});


window.addEventListener('customer.enquiry', (e) => {
    // let store = e.detail.store;
});

window.addEventListener('customer.subscribe', (e) => {
    let params = e.detail.formParams;
    postToSharpSpring(params);
});

window.addEventListener('customer.register', (e) => {
    let params = e.detail.formParams;
    postToSharpSpring(params);
});

function postToSharpSpring(params){
    var __ss_noform = window.__ss_noform || [];

    var url = 'https://app-3QNP1F5B2A.marketingautomation.services/webforms/receivePostback/MzawMLEwMzG0BAA/';
    var endpoint = '21001cc3-24ec-4c6f-8249-7e3e92d08c8c';
    var endpointurl = url + endpoint + '/jsonp/';

    let ssTracking = $.cookie('__ss_tk');
    params += '&trackingid__sb='+ssTracking;

    window.jsonp(endpointurl+'?'+params, null, (err, data) => {
        console.log(err, data)
    });

    return true;
}

